import React from 'react';
import EquivalentSection from '../Components/equivalentSection';
import heroImage from '../../Assets/TreePlanting/TreePlantingHero.png';
import heroMobile from '../../Assets/TreePlanting/TreePlantingMobileHero.png';
import Footer from '../Components/footer';
import Hero from '../Components/hero';
import HowDoesItWork from '../Components/howDoesItWork';
import RecentProjects from '../Components/recentProjects';
import WhereAreTreesPlanted from '../Components/whereAreTreesPlanted';
import { useBreakPoints } from '../../Theming';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div``;

const TreePlanting: React.FC = () => {
  const { t } = useTranslation();
  const { mobile } = useBreakPoints();

  return (
    <Container>
      <Hero
        headerText={t('treePlanting.hero.heading')}
        subText={t('treePlanting.hero.subHeading')}
        bgImage={mobile ? heroMobile : heroImage}
      />
      <WhereAreTreesPlanted />
      <HowDoesItWork />
      <RecentProjects />
      <EquivalentSection />
      <Footer />
    </Container>
  );
};

export default TreePlanting;
